import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { toast } from "sonner";
import { Save, Plus, Trash2 } from "lucide-react";
import DropZone from "../components/DropZone";

function resolveSrc(u) { if (!u) return ""; if (u.startsWith("http")) return u; if (u.startsWith("/api/media/")) return `${process.env.REACT_APP_BACKEND_URL}${u}`; return u; }

export default function SobreVideosEditor() {
  const [items, setItems] = useState([]);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    api.get("/content/kv/sobre_videos").then(({ data }) => Array.isArray(data) && setItems(data));
  }, []);

  const upd = (i, k, v) => setItems((arr) => { const a = [...arr]; a[i] = { ...a[i], [k]: v }; return a; });
  const add = () => setItems((arr) => [...arr, { title: "", poster: "", url: "" }]);
  const remove = (i) => setItems((arr) => arr.filter((_, j) => j !== i));

  const save = async () => {
    setSaving(true);
    try { await api.put("/content/kv/sobre_videos", { value: items }); toast.success("Vídeos da Sobre salvos."); }
    catch { toast.error("Erro ao salvar."); }
    finally { setSaving(false); }
  };

  return (
    <div>
      <div className="flex justify-between items-end mb-6">
        <div>
          <h1 className="font-display text-4xl">Vídeos da Sobre</h1>
          <p className="text-sm text-neutral-500 mt-1">Linha com 3 vídeos abaixo do vídeo principal. Recomendado: capa 1920×1080.</p>
        </div>
        <button onClick={save} disabled={saving} data-testid="sobre-videos-save" className="bg-black text-white text-sm px-5 py-2.5 rounded-full hover:bg-accent-orange disabled:opacity-50"><Save className="w-3 h-3 inline mr-1" /> {saving ? "Salvando…" : "Salvar"}</button>
      </div>

      <section className="border border-black/10 p-5 rounded">
        <div className="flex justify-between items-center mb-4">
          <div className="font-semibold text-sm uppercase tracking-widest text-neutral-700">Vídeos ({items.length}) · 3 por linha</div>
          <button onClick={add} className="text-xs bg-accent-yellow px-3 py-1 rounded-full font-semibold" data-testid="sobre-video-add"><Plus className="w-3 h-3 inline" /> Adicionar</button>
        </div>
        <div className="grid md:grid-cols-2 gap-4">
          {items.map((v, i) => (
            <div key={i} className="border border-black/10 p-4 rounded space-y-3" data-testid={`sobre-video-${i}`}>
              <div className="flex justify-between items-center">
                <div className="text-xs font-semibold text-neutral-500">Vídeo {i + 1}</div>
                <button onClick={() => remove(i)} className="text-red-500"><Trash2 className="w-4 h-4" /></button>
              </div>
              <div>
                <label className="text-xs text-neutral-500">Título</label>
                <input value={v.title || ""} onChange={(e) => upd(i, "title", e.target.value)} className="w-full border border-black/15 px-2 py-1.5 rounded text-sm" placeholder="Construção de Marca" />
              </div>
              <div>
                <label className="text-xs text-neutral-500">Imagem de capa (16:9)</label>
                {v.poster && <img src={resolveSrc(v.poster)} alt="" className="w-full aspect-video object-cover rounded my-2" />}
                <DropZone multiple={false} onUploaded={(f) => upd(i, "poster", f.url)} />
                <input value={v.poster || ""} onChange={(e) => upd(i, "poster", e.target.value)} placeholder="ou URL" className="w-full text-xs border border-black/15 px-2 py-1.5 rounded mt-1" />
              </div>
              <div>
                <label className="text-xs text-neutral-500">Vídeo — upload direto (MP4, WebM, MOV · até 100MB)</label>
                {v.url && (v.url.includes(".mp4") || v.url.includes(".webm") || v.url.includes(".mov") || v.url.startsWith("/api/media/")) && (
                  <video src={resolveSrc(v.url)} controls className="w-full aspect-video rounded my-2 bg-black" />
                )}
                <DropZone multiple={false} accept={{ "video/*": [".mp4", ".webm", ".mov", ".m4v"] }} hint="Vídeos · até 100MB" onUploaded={(f) => upd(i, "url", f.url)} />
              </div>
              <div>
                <label className="text-xs text-neutral-500">…ou URL de vídeo externo (Vimeo, YouTube — abre em nova aba)</label>
                <input value={v.url || ""} onChange={(e) => upd(i, "url", e.target.value)} data-testid={`sobre-video-url-${i}`} className="w-full border border-black/15 px-2 py-1.5 rounded text-sm" placeholder="https://vimeo.com/... ou URL enviada acima" />
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
